export default __webpack_public_path__ + "static/xin-huang-layer5-maintainer-0c494550aa563d9e3eb3e6ac27fe285b.png";